import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
    <motion.span
      className={`block will-change-transform ${className}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const ParallaxImage = ({ src, alt, className = "", imgClassName = "", testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        data-testid={testId}
        src={src}
        alt={alt}
        style={{ y, scale: 1.18 }}
        className={`h-full w-full object-cover will-change-transform ${imgClassName}`}
      />
    </div>
  );
};

export const ClipReveal = ({ children, delay = 0.4, className = "" }) => {
  const [done, setDone] = useState(false);
  return (
    <motion.div
      className={className}
      initial={{ clipPath: "inset(100% 0 0 0)" }}
      animate={{ clipPath: "inset(0% 0% 0% 0%)" }}
      transition={{ duration: 1.3, delay, ease: EASE }}
      onAnimationComplete={() => setDone(true)}
      style={done ? { clipPath: "none" } : undefined}
    >
      {children}
    </motion.div>
  );
};
